import React from 'react'
import PropTypes from 'prop-types';
import defaultImg from '../images/room-1.jpeg'
import {Link} from 'react-router-dom'



export default function Room({room}) {
    const {name, slug,images,price} = room
    return (
        <article className='room'>
            <div className="img-container">
                <img src={images[0] || defaultImg}  alt="featured room" />
                <div className="price-top">
                    <h6>${price}</h6>
                    <p>Per night</p>
                </div>
                <Link to={`/rooms/${slug}`} className="btn-primary room-link">Feature</Link>
            </div>
            <p className="room-info">{name}</p>
        </article>
    )
}



// forcing Type of props *Important for big project*
Room.propTypes = {  
    room : PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug : PropTypes.string.isRequired,
        price : PropTypes.number.isRequired,
        images : PropTypes.arrayOf(PropTypes.string).isRequired
    })
    
};
